import { render } from "./PieChartComponent.vue?vue&type=template&id=1418b5f5&scoped=true"
import script from "./PieChartComponent.vue?vue&type=script&lang=js"
export * from "./PieChartComponent.vue?vue&type=script&lang=js"

import "./PieChartComponent.vue?vue&type=style&index=0&id=1418b5f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1418b5f5"]])

export default __exports__